import { FormGroup, FormControl } from "@angular/forms";
import { DeviceBase } from "./device-base";
import { PropertyMetadata } from "../../properties/property-types";
import { RegisterElement } from "../element-decorator";
import { ParkingLevelElement } from "../parking/parkinglevel";
import { ElementValidationResult, LevelDesignerElementBase } from "../element-base";

@RegisterElement()
export class ParkingMeter extends DeviceBase {
    protected sizeInMeters: number = 1;
    public override TypeName: string = "ParkingMeter";
    public override ParentType: string | null = "ParkingLevel";
    public override ParentFormGroupName: string | null = "ParkingMeterConfigurations";

    constructor(formGroup: FormGroup) {
        super(formGroup, 'assets/icons/parkingmeter.svg');

        // Add specific parking meter controls
        if (!formGroup.contains('ExternalId')) {
            formGroup.addControl('ExternalId', new FormControl(''));
        }
        if (!formGroup.contains('TimeoutMinutes')) {
            formGroup.addControl('TimeoutMinutes', new FormControl(5));
        }

        const idValue = formGroup.get('Id')?.value;
        if (idValue != null && typeof idValue !== 'number') {
            const parsed = Number(idValue);
            formGroup.get('Id')?.setValue(Number.isFinite(parsed) ? parsed : null);
        }
    }

    public override clone(): ParkingMeter {
        const cloneGroup = new FormGroup({});
        Object.entries(this.formGroup.controls).forEach(([key, ctrl]) => {
            if (key === 'Id' || key == 'ChipId') {
                return;
            }
            
            cloneGroup.addControl(key, new FormControl(ctrl.value));
        });
        return new ParkingMeter(cloneGroup);
    }

    public override getPropertyMetadata(): PropertyMetadata[] {
        return [
            ...super.getPropertyMetadata(),
            {
                formControlName: 'ExternalId',
                displayName: 'External ID',
                inputType: { type: 'text' },
                order: 3,
                category: 'General',
                hideOnMultipleSelection: false,
            },
            {
                formControlName: 'TimeoutMinutes',
                displayName: 'Timeout Minutes',
                inputType: { type: 'number' },
                order: 4,
                category: 'General',
                hideOnMultipleSelection: false,
            },
        ];
    }

    public override default(): ParkingMeter {
        return this;
    }
}
